import { Pagination } from "@nextui-org/react";
import timeAgo from "../../helper/timeago";
import useAxios from "../../hooks/useAxios";
import { useEffect, useRef, useState } from "react";
import {  useNavigate, useSearchParams } from "react-router-dom";

const Tickets = ({ status, setOnTicket, role }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { AxiosPrivate } = useAxios()
    const [currentPage, setCurrentPage] = useState(1)
    const pagination = useRef()

    const [tickets, setTickets] = useState()

    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get(`/ticket/${role}-index?status=${status}&page=${currentPage}`)
                .then(({ data }) => {
                    setTickets(data.data.data)
                    pagination.current = data ? Math.ceil(data.data.total / data.data.per_page) : 1
                })
                .catch(err => alert(err.response?.data.message))
        }
        get()
    }, [status, currentPage])

    const getOneTicket = (ticket) => {
        setOnTicket(ticket)
        const newParams = new URLSearchParams(searchParams);
        newParams.set('ticket', ticket.id);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
    }
    return (
        <>
            {!!tickets
                ? <div className="flex flex-col items-center" dir="rtl">
                    <ul className="flex flex-wrap justify-between gap-3 w-full">
                        {tickets.length ? tickets.map(t => {
                            return <li key={t.id} onClick={() => getOneTicket(t)} className="md:max-w-[49%] max-w-full w-full border p-4 text-sm rounded-lg shadow-md cursor-pointer">
                                <div className="flex items-center justify-between w-full mb-4">
                                    <p className="font-bold">{t.sender_name}</p>
                                    <p className="text-xs">{timeAgo(t.created_at)}</p>
                                </div>
                                <div className="w-full line-clamp-1 text-right">{t.subject}</div>
                            </li>
                        }) : <div className="mx-auto">تیکتی وجود نداره</div>}
                    </ul>
                    <div dir="auto" className="centerOfParent mt-4">
                        {!!tickets.length && pagination.current > 1 &&
                            <Pagination size='sm'
                                total={Math.ceil(pagination.current)}
                                color="primary"
                                page={currentPage}
                                onChange={setCurrentPage}
                                showControls
                            />}
                    </div>
                </div>
                : <div className="mx-auto">درحال بارگزاری...</div>
            }
        </>
    );
};

export default Tickets;